import styled from "styled-components";

export const HybridEmbeddedGameLoadingIndicatorProgressCircle1Box = styled.div`
  height:100px;
  width:100px;
  border-radius: 50%;
  background: ${props => props.theme.colors.boxBorderContrast};
  margin-top: 10px;
`

export const HybridEmbeddedGameLoadingIndicatorProgressCircle2Box = styled.div<{angle: number}>`
  height: 100%;
  width: 100%;
  border-radius: 50%;
  background: conic-gradient(${props => props.theme.colors.brandPrimary} ${props => props.angle}deg, transparent ${props => props.angle}deg 100%);
`

export const HybridEmbeddedGameLoadingIndicatorProgressCircle3Box = styled.div`
  position:relative;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  height:92%;
  width:92%;
  top:4%;
  left:4%;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.backgroundDark};
  color: ${props => props.theme.colors.brandPrimary};
`
